import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { CANCELED } from 'settings/_scheduleStatusSettings'

import { 
  CancelationScheduleParams, 
  CancelationScheduleRequest, 
  OptionData, 
  UseCancelationSchedule 
} from '../types'

async function cancelScheduleService({
  scheduleId,
  requestedBy,
  reasonCode,
  details
}: CancelationScheduleRequest): Promise<AxiosResponse> {

  const requestBody = {
    status_code: CANCELED,
    requested_by: requestedBy,
    reason_code: reasonCode,
    details
  }

  const response = await axios.put(apiEndpoints.SCHEDULE_DETAIL(scheduleId), requestBody)

  return response
}

export const useCancelationSchedule = ({ 
  scheduleId,
  requesterUsername
}: CancelationScheduleParams): UseCancelationSchedule => {
  const [cancelationFields, setCancelationFields] = useState({
    cancelationReason: '',
    cancelationDetails: '',
  })

  const { mutate: handleCancelSchedule, isSuccess, isLoading, isError } = useMutation({
    mutationFn: () => cancelScheduleService({
      scheduleId: scheduleId,
      requestedBy: requesterUsername,
      reasonCode: cancelationFields.cancelationReason,
      details: cancelationFields.cancelationDetails,
    }),
  })

  function handleChangeReason(data: OptionData) {
    setCancelationFields({
      ...cancelationFields,
      cancelationReason: data.code,
    })
  }

  function handleChangeDetails(value: string) {
    setCancelationFields({
      ...cancelationFields,
      cancelationDetails: value,
    })
  }

  function validateRequiredFields() {
    const { cancelationReason } = cancelationFields

    if (!cancelationReason) {
      return false
    }

    return true
  }

  return {
    cancelationFields,
    validateRequiredFields,
    handleChangeReason,
    handleChangeDetails,
    handleCancelSchedule,
    isCancelationSuccess: isSuccess,
    isCancelationLoading: isLoading,
    isCancelationError: isError,
  }
}